<div class="sub-header px-3">
</div>
<div class="search-container align-items-center d-flex row mb-4 px-3 mb-2 pb-4">
  <app-confirm-popup [triggerModal]="showModal" *ngIf="showModal" [title]="'Delete'" [message]="'Are you sure to delete the selected Dimensions ? '"
    [confirmText]="'Delete'" [cancelText]="'Cancel'" (confirm)="onDeleteConfirm()"
    (cancel)="onDeleteCancel()"></app-confirm-popup>
  <h4 class="col-md-8 mb-0 mt-2"> Size Definition</h4>
  <div class="catalog-options-wrapper px-2 mt-3">
    <ul class="nav">
      @for(item of dimArrList;track item.id) {
      <li class="nav-item">
        <a (click)="handleTab(item)" [ngClass]="item.clicked ? 'active-tab' : ''"
          class="nav-link active">{{item.name}}</a>
      </li>
      }
    </ul>
  </div>
</div>
<div class="p-4">
  <div  class="p-4 dim-list-container" [ngStyle]="{'overflow-y':dimArrData && dimArrData.length>0 ? 'scroll': 'hidden'}">
    <div class="dim-search-container px-0 row">
      <div *ngIf="!reOrderTableRows" class="col-md-6 d-flex align-items-start">
        <nz-input-group class="px-2 mr-2 search-input-group" style="width: 80%;" nzSize="default"
          [nzSuffix]="suffixIconSearch">
          <input type="text" class="py-1" nz-input placeholder="Search For Dimensions"
           (keydown)="onlyAlphanumeric($event)" uppercase maxlength="3"
            (keydown.enter)="searchDimValue(SearchText.value)" [(ngModel)]="searchText"
             nzAllowClear #SearchText />
          <span class="close-icon" (click)="SearchText.value = '';searchDimValue('')" class="px-1" nz-icon
            nzType="close-circle"></span>

        </nz-input-group>
        <ng-template #suffixIconSearch>
          <span class="search-icon" (click)="searchDimValue(SearchText.value)" nz-icon nzType="search"></span>
        </ng-template>
        <button nz-button class="ml-10">
          <!-- <span nz-icon [nzType]="'sort-descending'"></span> -->
        </button>
        <button nz-button class="ml-10">
          <!-- <span nz-icon [nzType]="'filter'"></span> -->
        </button>
      </div>
      <div *ngIf="reOrderTableRows" class="col-md-6 d-flex align-items-start">
        <h4 class="col-md-8 mb-0 mt-2">Reorder Dimensions</h4>
      </div>

      <div *ngIf="!reOrderTableRows" class="col-md-6 d-flex align-items-start justify-content-end">
        <button nz-button nzType="default" class="d-flex align-items-center mr-10" [nzSize]="'default'"
          (click)="linkDrawer = !linkDrawer">
          <span nz-icon nzType="plus"></span>Add New Dimension
        </button>
        <button nz-button nzType="default" (click)="deAssociate()" [disabled]="selectedIds.size == 0"
          class="d-flex align-items-center mr-10" [nzSize]="'default'">
          <span nz-icon nzType="delete"></span>Delete
        </button>
        <button nz-button >
          <span  nz-dropdown nz-icon nzTrigger="click" [nzType]="'ellipsis'" [nzDropdownMenu]="menu"></span>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu class="category-options px-1 mt-1">
              <li nz-menu-item (click)="showReorderRows()"> <img class="expand-icon px-1"
                  src="swap.png" />Reorder</li>
            </ul>
          </nz-dropdown-menu>
        </button>
      </div>

      <div *ngIf="reOrderTableRows" class="col-md-6 d-flex justify-content-end">
        <button (click)="cancelReorder()" nz-button nzType="default"
          class="ant-btn mr-10 ant-btn-default" [nzSize]="'default'">
          <span>Cancel</span>
        </button>
        <button (click)="saveReorderedList()" nz-button nzType="primary" class="ant-btn mr-10 ant-btn-primary"
          [nzSize]="'default'">
          <span nz-icon nzType="check"></span>Ok
        </button>
      </div>

    </div>
    <ng-container *ngIf="dataLoaded">
   <app-spinner></app-spinner>
    </ng-container>
    <ng-container *ngIf="dimArrData.length > 0 && !dataLoaded">
      <app-data-grid [tableHeight]="'65vh'" [reOrderTable]="reOrderTableRows" (updateRow)="updateRow($event)"
        [columns]="dimColumns" [dataSet]="dimArrData" [gridStyle]="'white'" (deleteRow)="deleteRow($event)"
        (selectedRows)="selectedRows($event)" [dropdownList]="garmentTypes" [frontPagination]="false"
        (reOrderedRows)="getReorderedList($event)" (tableScroll)="onTableScroll($event)" [searchTerm]="searchText"  ></app-data-grid>
    </ng-container>
  </div>
</div>
<nz-drawer [nzMaskClosable]="false" [nzKeyboard]="false" [nzWidth]="920" [nzVisible]="linkDrawer" [nzTitle]="activeTab == 'Dimension 1' ? 'Add New Dim1' : 'Add New Dim2'"
  (nzOnClose)="linkDrawer = false">
  <ng-container *nzDrawerContent>
    <app-add-new-sequence (linkDrawer)="linkDrawer = false;ngOnInit()" [selectedTab]="activeTab"
      [garmentTypes]="garmentTypes"></app-add-new-sequence>
  </ng-container>
</nz-drawer>